// extracted by mini-css-extract-plugin
export default {"wrapper":"mz-z","response":"nz-z","error":"oz-z","disabled":"pz-z","buttons":"qz-z","feedbackQuestionSection":"rz-z","yesNoWrapper":"sz-z"};